import React from 'react';
import { useTranslation } from 'react-i18next';

interface Kpi {
  title: string;
  value: string | number;
}

interface KpiCardProps {
  title: string;
  kpis: Kpi[];
}

const KpiCard: React.FC<KpiCardProps> = ({ title, kpis }) => {
  const { t } = useTranslation();
  if (kpis.length === 1) {
    const kpi = kpis[0];
    return (
      <div className="rounded-lg">
        <p>{kpi.title} <span className='font-bold'>{kpi.value}</span></p>
      </div>
    );
  }

  return (
    <div className="rounded-lg overflow-hidden border border-border">
      {title && (
        <div className="bg-surface-alt px-6 py-3">
          <h3 className="text-sm font-semibold text-text">{title}</h3>
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead className="bg-header text-on-primary">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider"
              >
                {t('alpha.kpi.kpiHeader')}
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider"
              >
                {t('alpha.kpi.valueHeader')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {kpis.map((kpi, index) => (
              <tr key={`${kpi.title}-${index}`} className="bg-surface hover:bg-surface-alt">
                <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-text">
                  {kpi.title}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-primary font-semibold">
                  {kpi.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default KpiCard;